<template>
    <div class="bg-white">
        <Mainlayout></Mainlayout>
        <CCol sm="12" style="background-size: cover;background:linear-gradient(0deg, #26224E 0%, #26224E 100%), url(<path-to-image>) lightgray 50%">
            <CCol sm="12" lg="12">
                <CRow>
                    <CCol sm="12" lg="12">
                        <div style="margin: 5%">
                            <div class="text-center">
                                <br /><br /><br />
                                <h1 class="custom-text-aladdin text-white poppin-font text-48px">
                                    AI-Based Public Complaint <br />Reporting System of the Royal Malaysia Police
                                </h1>
                                <CContainer>
                                    <p class="custom-16px-400 text-center ml-4 text-white">A smart platform to help the public file reports more easily and efficiently. This system uses AI to transcribe and capture important information automatically, ensuring your report is complete and accurate.
                                    </p>
                                    <CButton class="b-20 button-Explore-nav">Report Your Case</CButton>
    
                                </CContainer>
                                <br /><br /><br />
    
                            </div>
    
    
    
                        </div>
                        <br />
    
                    </CCol>
    
                </CRow>
            </CCol>
        </CCol>
    
        <CCol sm="12">
            <CContainer>
                <h3 class="custom-40px-600 text-center mt-5">How It Works</h3>
                <p class="custom-18px-400 text-center mb-5" style="color:#696969">Get to know the talented individuals driving our company forward.</p>
    
                <CRow class="d-flex">
                    <!-- First Card -->
                    <CCol sm="4" class="d-flex align-items-stretch">
                        <div class="position-relative w-100">
                            <CCard class="custom-border-EAECF0 d-flex flex-column h-100 p-0">
    
                                <CCardBody class="flex-grow-1">
                                    <img src="../assets/img/smallicon/camera.png" style="width:30px" class="m-2" />
                                    <h3 class="custom-24px-500 text-left ml-2"> Upload</h3>
                                    <p class="custom-16px-400 text-left ml-2">
                                        Record your complaint, and the AI will automatically transcribe and capture important information.
                                    </p>
                                </CCardBody>
                            </CCard>
                            <!-- Arrow -->
                            <img src="../assets/img/smallicon/horizontalarrow.png" class="arrow-overlay" style="width: 50px; position: absolute; top: 50%; right: -25px; transform: translateY(-50%);" />
                        </div>
                    </CCol>
    
                    <!-- Second Card -->
                    <CCol sm="4" class="d-flex align-items-stretch">
                        <div class="position-relative w-100">
                            <CCard class="custom-border-EAECF0 d-flex flex-column h-100 p-0">
    
                                <CCardBody class="flex-grow-1">
                                    <img src="../assets/img/smallicon/semakan.png" style="width:30px" class="m-2" />
                                    <h3 class="custom-24px-500 text-left ml-2">AI Review</h3>
                                    <p class="custom-16px-400 text-left ml-2">
                                        The AI processes the data to ensure that all details have been accurately identified.
                                    </p>
                                </CCardBody>
                            </CCard>
                            <!-- Arrow -->
                            <img src="../assets/img/smallicon/horizontalarrow.png" class="arrow-overlay" style="width: 50px; position: absolute; top: 50%; right: -25px; transform: translateY(-50%);" />
                        </div>
                    </CCol>
    
                    <!-- Third Card -->
                    <CCol sm="4" class="d-flex align-items-stretch">
                        <CCard class="custom-border-EAECF0 d-flex flex-column h-100 p-0">
    
                            <CCardBody class="flex-grow-1">
                                <img src="../assets/img/smallicon/ektract.png" style="width:30px" class="m-2" />
                                <h3 class="custom-24px-500 text-left ml-2">AI Data Extraction </h3>
                                <p class="custom-16px-400 text-left ml-2">
                                    Information is automatically filled into the form, and you can review or edit it before the final report.
                                </p>
                            </CCardBody>
                        </CCard>
                    </CCol>
                </CRow>
            </CContainer>
            <br /> <br /> <br />
        </CCol>
        <CCol sm="12" class="bg-gradient-grey">
            <CContainer>
                <CRow>
                    <CCol sm="12">
                        <h3 class="custom-30px-600 mt-4 text-center">Record your report</h3>
                        <p class="custom-16px-400 font-color-98A2B3 text-center mb-4">Upload your references, or other documents to enhance your report. (if required)</p>
                    </CCol>
                    <!-- <video controls playsinline muted width="600">
      <source src="https://s3.ap-southeast-1.amazonaws.com/files.interviewrr/tmpini9rczc_output.mp4" type="video/mp4">
      Your browser does not support the video tag.
    </video>
                        <video controls width="600">
      <source src="https://s3.ap-southeast-1.amazonaws.com/files.interviewrr/var/folders/zf/dbhdjtbd3b3f8x435km5wjs00000gq/T/tmpini9rczc_output.mp4" type="video/mp4">
      Your browser does not support the video tag.
    </video> 
    <iframe src="https://s3.ap-southeast-1.amazonaws.com/files.interviewrr/var/folders/zf/dbhdjtbd3b3f8x435km5wjs00000gq/T/tmpini9rczc_output.mp4"></iframe> -->
    
                    <!-- <CCol sm="12">
                            <img src="../assets/img/smallicon/video.png" style="max-width:100%" />
                        </CCol> -->
                    <CCol sm="12">
                        <CContainer>
                            <CCol sm="12">
                                <label class="custom-16px-400">Please provide the following details:
	•	Name
	•	Phone Number (Ensure each digit is clearly spelled out)
	•	Email Address
	•	Complaint Details
	•	Location of Complaint (Clearly spell out each number, street name, or place to avoid confusion)</label>
                            </CCol>
    
    
                            <CCol sm="12">
                                <div class="video-container">
                                    <video :class="{ hideAfterStop: toggleVideo }" ref="videoElement" autoplay></video>
                                    <div class="timer" v-if="isRecording">
                                        {{ formatTime(elapsedTime) }} 
    
                                    </div>
                                    <div class="button-container">
                                        <CRow>
                                            <CCol sm="4">
    
                                                <button class="record-button" @click="toggleRecording(index)" :class="{ recording: isRecording }">
                                                              <i v-if="!isRecording" class="fas fa-play"></i>
                                                              <i v-else class="fas fa-stop"></i>
                                                            </button>
                                            </CCol>
                                        </CRow>
                                    </div>
                                </div>
                            </CCol>
                            <h3 class="custom-18px-600 text-center font-color-171717 mt-3" v-if="!isRecording && hideNextButton">Click <strong>Red Button</strong> to Start</h3>
                            <h3 class="custom-18px-600 font-color-171717 text-center mt-3" v-if="isRecording"> Click <strong>Green Button</strong> to stop</h3>
                      
        
               
                        </CContainer>
                    </CCol>
                    <CCol sm="12">
                        <CRow>
    
                            <CCol sm="12">
                                <h4 class="custom-20px-700 mt-4">
                                    Note
                                </h4>
                                <CRow>
                                    <CCol sm="1">
                                        <p class="custom-18px-500 font-color-171717 text-right">*</p>
                                    </Ccol>
                                    <CCol sm="11">
                                        <p class="custom-18px-500 font-color-171717">Before recording, make sure you are in a quiet place so that your voice can be clearly captured by the system.</p>
                                    </CCol>
    
    
    
                                    <CCol sm="1">
                                        <p class="custom-18px-500 font-color-171717 text-right">*</p>
                                    </Ccol>
                                    <CCol sm="11">
                                        <p class="custom-18px-500 font-color-171717">Explain your complaint briefly but in detail, including important information such as the location, time, and parties involved (if applicable).</p>
                                    </CCol>
    
                                    <CCol sm="1">
                                        <p class="custom-18px-500 font-color-171717 text-right">*</p>
                                    </Ccol>
                                    <CCol sm="11">
                                        <p class="custom-18px-500 font-color-171717">After the recording, you will have the opportunity to review the transcription and ensure all information is accurately recorded before proceeding to the next step.</p>
                                    </CCol>
                                </CRow>
    
    
    
    
    
                            </CCol>
                        </CRow>
    
                    </CCol>
                </CRow>
            </CContainer>
        </CCol>
    
    
    
    
        <div v-if="showConfirmationDialog" class="popup-all backdrop-all">
            <div class="popup-all1">
                <!-- Popup content -->
                <div class="text-center">
                    <h3 class="custom-18px-700 text-center">
                        Would you like to record voice only or video with voice?
                    </h3>
                </div>
                <div class="justify-content-between m-0 text-center">
                    <CButton class="custom-border-purple text-white p-2 mr-2" @click="allowCamera"><img src="../assets/img/Video 3.png" style="max-width:20px" /><span class="ml-2 mr-2">Video</span></CButton>
                    <CButton class="badge-purple p-2" @click="denyCamera"><img src="../assets/img/Voice.png" style="max-width:20px" /><span class="ml-2 mr-2 font-color-928AFD">Voice only</span></CButton>
    
                </div>
    
                
            </div>
        </div>

        <div v-if="showProcessUpload" class="popup-all backdrop-all">
            <div class="popup-all1">
                <!-- Popup content -->
                <div class="text-center">
                    <img src="../assets/img/all/uplaod.png" width="100px"/>
                    <h3 class="custom-18px-700 text-center">
                        📤 Uploading Your Recording...
                    </h3>
                    <p class="font-color-6C7278 text-center">Please wait, your recording is being processed by the system.</p>
                </div>
                <div class="justify-content-between m-0 text-center">
                    <CButton class="badge-purple p-2" @click="ClosePopupUpload()"><span class="ml-2 mr-2 font-color-928AFD">Cancel</span></CButton>

                </div>
            </div>
        </div>
                
    
        <Footerlayout></Footerlayout>
    </div>
</template>


<script>
import Vue from "vue";
import { Carousel3d, Slide } from "vue-carousel-3d";
import MarqueeText from "vue-marquee-text-component";

Vue.component("marquee-text", MarqueeText);
import AOS from "aos";
import "aos/dist/aos.css";

Vue.use(Carousel3d);

import backgroundUrl from "../assets/img/bgPurpleYellow.png";
import backgroundUrl1 from "../assets/img/BgPeople.png";
import backgroundMap from "../assets/img/Map.png";
import backgroundUrlTestimoni from "../assets/img/bgBluesquare.png";

import Mainlayout from "../containers/AllHeader.vue";
import MainlayoutLogin from "../containers/LoginHeader.vue";
import Footerlayout from "../containers/TheFooter.vue";
import ToggleCard from '../components/Toggle.vue';
import backgroundUrNoArrow from "../assets/img/bgline.png";

export default {
    name: "Login",
    components: {
        Carousel3d,
        Slide,
        MarqueeText,
        Mainlayout,
        MainlayoutLogin,
        Footerlayout,
        ToggleCard
    },

    data() {
        return {
            backgroundUrl,
            backgroundUrl1,
            backgroundMap,
            backgroundUrlTestimoni,
            isActive: false,
            backgroundUrNoArrow,

            Names: "",
            loading: true,

            mediaRecorder: null,
            recordedChunks: [],
            isRecording: false,
            toggleVideo: false,
            uploadProgress: 0,
            questions: {},
            index: 1,

            question: {},

            showQuestion: true,
            showQuestion2: false,
            isNextButtonDisabled: true,

            elapsedTime: 0,
            timerInterval: null,
            isLanguagePopupVisible2: false,
            PopupFeedback: false,
            rating: 0,
            comment: '',
            SuccessPopup: false,
            instructionText: "You will see the question once you click the record button.",
            showInstruction: "",
            checking: {},
            showConfirmationDialog: false,
            cameraAccessDenied: false,
            Error: false,
            user: {},
            Message: "",
            showStartSurvey: false,
            showMain: true,

            showPopup: false,


            hideNextButton: true,

            showNotes: false,

            uploadedFiles: [],
            document: [],
            uploadProgressBar: {},
            videoUrl: "https://s3.ap-southeast-1.amazonaws.com/files.interviewrr/tmpini9rczc_output.mp4",
            showProcessUpload: false,

            sess: {}


        };
    },
    created() {
        AOS.init();
    },
    async mounted() {
        try {
            const isAuth = await this.UserAuth();
            if (isAuth) {
                await this.GetInfoUser();
                await this.getSessionUser();
                // await this.getListQuestion(this.index);
            } else {
                this.GoToLogin();
            }
        } catch (error) {
            this.GoToLogin();
            console.error("Error during authentication:", error);
            // Handle the error here
        }
    },
    methods: {
        toggle() {
            this.isActive = !this.isActive;
        },
        GoToVideo() {
            this.$router.push("InterviewerrVideo");
        },
        async GetInfoUser() {
            try {
                const response = await this.$API.get(this.$LoginUserDetail, { withCredentials: true });
                if (response.status === 200 && response.data) {
                    this.user = response.data;
                    this.Names = this.user.name;
                } else {
                    this.$router.push("HowItWork");
                    console.error("User info retrieval failed:", response.data.detail);
                }
            } catch (error) {
                this.$router.push("HowItWork");
                console.error("Error fetching user info:", error);
            }
        },
        timeStringToSeconds(timeString) {
            if (typeof timeString !== 'string') {
                console.error("Expected a string for time format, but received:", timeString);
                return 0; // Return a default value or handle it as needed
            }

            const timeParts = timeString.split(":").map(Number);

            if (timeParts.length === 3) {
                // If time string is in "hh:mm:ss" format
                const [hours, minutes, seconds] = timeParts;
                return (hours * 3600) + (minutes * 60) + seconds;
            } else if (timeParts.length === 2) {
                // If time string is in "mm:ss" format
                const [minutes, seconds] = timeParts;
                return (minutes * 60) + seconds;
            } else {
                // Handle unexpected formats
                console.error("Invalid time format:", timeString);
                return 0;
            }
        },

        async startRecording(index) {
            try {
                // Safely get the maxTimeLimit based on index
                let maxTimeLimitStr = index === 1 ? this.questions.maxTimeLimit : this.question ?.maxTimeLimit;
                const maxTimeLimitInSeconds = this.timeStringToSeconds(maxTimeLimitStr);
                console.log("Max Time Limit in Seconds:", maxTimeLimitInSeconds);


                // Check if camera access was denied before
                if (this.cameraAccessDenied) {
                    return this.startRecordingAudio(index); // Proceed with audio recording only
                }

                // Request video and audio stream
                const stream = await navigator.mediaDevices.getUserMedia({
                    video: {
                        width: { ideal: 1280 },
                        height: { ideal: 720 },
                        frameRate: { ideal: 30 },
                    },
                    audio: {
                        echoCancellation: true,
                        noiseSuppression: true,
                        sampleRate: 44100,
                    },
                });

                // Set up the video element and media recorder
                this.$refs.videoElement.srcObject = stream;
                this.$refs.videoElement.muted = true;
                this.mediaRecorder = new MediaRecorder(stream);

                this.mediaRecorder.ondataavailable = (event) => {
                    if (event.data.size > 0) {
                        this.recordedChunks.push(event.data);
                    }
                };

                this.mediaRecorder.onstop = () => {
                    this.handleRecordingStop(index);
                };

                this.mediaRecorder.start();
                this.isRecording = true;
                this.isNextButtonDisabled = true;
                this.elapsedTime = 0;
                this.timerInterval = setInterval(() => {
                    this.elapsedTime++;
                    // if (this.elapsedTime >= 120) {
                    //     this.stopRecording();
                    // }
                   
                }, 1000);




            } catch (error) {
                console.error("Error accessing media devices: ", error);
                alert("Error accessing media devices. No device found.");
            }
        },

        // async startRecordingAudio(index) {
        //     try {


        //         // Request audio-only stream
        //         const stream = await navigator.mediaDevices.getUserMedia({
        //             audio: {
        //                 echoCancellation: true,
        //                 noiseSuppression: true,
        //                 sampleRate: 44100,
        //             },
        //         });

        //         // Set up the media recorder for audio
        //         this.mediaRecorder = new MediaRecorder(stream);

        //         this.mediaRecorder.ondataavailable = (event) => {
        //             if (event.data.size > 0) {
        //                 this.recordedChunks.push(event.data);
        //             }
        //         };

        //         this.mediaRecorder.onstop = () => {
        //             this.handleRecordingStop(index);
        //         };

        //         this.mediaRecorder.start();
        //         this.isRecording = true;

        //     } catch (error) {
        //         console.error("Error accessing media devices: ", error);
        //         alert("Error accessing media devices. No device found.");
        //     }
        // },

        async startRecordingAudio(index) {
    try {
        // Ensure recordedChunks is initialized
        this.recordedChunks = [];

        // Get available audio input devices
        const devices = await navigator.mediaDevices.enumerateDevices();
        const audioDevices = devices.filter(device => device.kind === "audioinput");

        if (audioDevices.length === 0) {
            throw new Error("No audio input devices found.");
        }

        // Request audio-only stream with default or first available device
        const stream = await navigator.mediaDevices.getUserMedia({
            audio: {
                deviceId: audioDevices[0]?.deviceId || "default",
                echoCancellation: true,
                noiseSuppression: true,
                sampleRate: 44100,
            },
        });

        // Set up the media recorder for audio
        this.mediaRecorder = new MediaRecorder(stream);

        this.mediaRecorder.ondataavailable = (event) => {
            if (event.data.size > 0) {
                this.recordedChunks.push(event.data);
            }
        };

        this.mediaRecorder.onstop = () => {
            this.handleRecordingStop(index);
        };

        // Small delay before starting recording (fix for some laptops)
        setTimeout(() => {
            this.mediaRecorder.start();
            this.isRecording = true;
            this.elapsedTime = 0;

            this.timerInterval = setInterval(() => {
                this.elapsedTime++;
            }, 1000);
        }, 200); // 200ms delay

    } catch (error) {
        console.error("Error accessing media devices: ", error);
        alert("Error accessing media devices. Please check microphone permissions.");
    }
},

        allowCamera() {
            this.showConfirmationDialog = false;
            this.allowCameraAccess = true;
            this.cameraAccessDenied = false; // Reset the camera access denial status

            // Proceed with the existing logic to start recording
            this.startRecording(1);
        },

        denyCamera() {
            this.showConfirmationDialog = false;
            this.allowCameraAccess = false;
            this.cameraAccessDenied = true; // Mark camera access as denied
            //alert("Camera access denied.");
            this.startRecordingAudio(1);
        },

        stopRecording() {
            if (this.mediaRecorder && this.mediaRecorder.state !== "inactive") {
                this.mediaRecorder.stop();
                if (this.$refs.videoElement.srcObject) {
                    const tracks = this.$refs.videoElement.srcObject.getTracks();
                    tracks.forEach((track) => track.stop());
                }
                this.$refs.videoElement.srcObject = null;
                this.recordedChunks = [];
                this.uploadProgress = 0;
                this.isRecording = false;
                clearInterval(this.timerInterval); // Stop the timer
                this.timerInterval = null;
                clearTimeout(this.stopRecordingTimeout);

            }
        },

        async handleRecordingStop(index) {
            this.showProcessUpload = true;
            const recordedBlob = new Blob(this.recordedChunks, {
                type: this.allowCameraAccess ? "video/webm" : "audio/webm",
            });

            this.recordedChunks = [];

            const formData = new FormData();
            formData.append("file", recordedBlob, this.allowCameraAccess ? "rekaman.webm" : "rekaman_audio.webm");
            formData.append("sessionId", this.sess.Id);

            this.$API.post(this.$UploadRecording, formData, {
                onUploadProgress: (progressEvent) => {
                    this.uploadProgress = Math.round(
                        (progressEvent.loaded / progressEvent.total) * 100
                    );
                },
            }).then((response) => {
                if (response.status === 200) {
                    this.videoId = response.data.recordId;
                  // this.InsertVideoText(this.videoId);
                    console.log("Successfully uploaded.");
                   // this.showProcessUpload = false;
                    setTimeout(() => {
            this.$router.push("BorangLaporan" + "?id=" + this.sess.Id);
        }, 10000); // 10,000 milliseconds = 10 seconds

                } else {
                    console.error("Failed to upload.");
                }
            }).catch((error) => {
                console.error("Error:", error);
            });

            this.isNextButtonDisabled = false;
        },

        async retryOperation(operation, retries = 7, delay = 1000) {
            let attempts = 0;
            while (attempts < retries) {
                try {
                    return await operation();
                } catch (error) {
                    attempts++;
                    console.error(`Attempt ${attempts} failed. Error: ${error.message}`);
                    if (attempts < retries) {
                        await new Promise((resolve) => setTimeout(resolve, delay));
                    } else {
                        console.error("All retry attempts failed.");
                        throw error;
                    }
                }
            }
        },
        InsertVideoText(videoId) {

            this.$API
                .get(this.$ExtractAudioText + "/" + videoId)
                .then((response) => {

                    if (response.status == 200) {
                        console.log("success convert");
                    } else {
                        this.Loading = false;
                        this.Error = true;
                        this.Message = response.data.message;
                    }
                })
                .catch((error) => {
                    this.Loading = false;
                    this.Error = true;
                    this.Message = error.response.data.message;
                    this.InsertVideoText(videoId);
                });
        },


        toggleRecording(index) {
            if (this.isRecording) {
                this.stopRecording();
            } else {
                if (index === 1) {
                    // For the first question, show confirmation dialog
                    this.showConfirmationDialog = true;
                } else {
                    // For subsequent questions, check if camera access is allowed
                    if (this.allowCameraAccess) {
                        this.startRecording(index);

                    } else {
                        this.startRecordingAudio(index);
                    }
                }
            }
        },




        SubmitData() {

            const field = this.$route.query.field;
            const expertise = this.$route.query.expertise;

            const formData = new FormData();

            formData.append("email", this.user.email);
            formData.append("experties", expertise);
            formData.append("field", field);

            this.$API
                .post(this.$RegisterInterest, formData)
                .then((response) => {
                    if (response.data.status === 400) {
                        this.Loading = false;
                        this.Message = response.data.message;
                        this.Error = true;
                    }
                    if (response.status == 200) {
                        if (response.data.status !== 400) {
                            if (response.data.status !== 400) {
                                this.isLanguagePopupVisible2 = true;
                            } else {
                                this.Loading = false;
                                this.Message = response.data.message;
                                this.Error = true;
                            }
                        } else {
                            this.Loading = false;
                            this.Message = response.data.message;
                            this.Error = true;
                        }
                    } else {
                        this.Loading = false;
                        this.Error = true;
                        this.Message = response.data.message;
                    }
                })
                .catch((error) => {
                    this.Loading = false;
                    this.Error = true;
                    this.Message = error.response.data.message;
                });
        },
        OpenHomepage() {
            // this.SignOut();
            this.SubmitEmail();
            this.InsertReport();
            this.SuccessPopup = true;

        },
        formatTime(seconds) {
            const minutes = Math.floor(seconds / 60);
            const secs = seconds % 60;
            return `${minutes.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
        },
        closePopup2() {
            this.isLanguagePopupVisible2 = false;
        },
        OpenFeedback() {
            this.isLanguagePopupVisible2 = false;
            this.PopupFeedback = true;
        },
        updateStars(index) {
            this.rating = index;
        },
        getStarSrc(index) {
            return index <= this.rating ? require('../assets/img/star-yellow.png') : require('../assets/img/star-grey.png');
        },
        async getSessionUser() {
        try {
            const response = await this.$API.get(this.$InsertSessionUser, { withCredentials: true });
            
            if (response.status === 200) {
                this.sess = response.data;
            } else {
                this.Loading = false;
                this.Error = true;
                this.Message = response.data || 'An error occurred';
            }
        } catch (error) {
            this.Loading = false;
            this.Error = true;
            this.Message = error.response?.data || 'An error occurred';
        }
        },
        SubmitFeedback() {
            this.PopupFeedback = false;
            const formData = new FormData();
            formData.append("comment", this.comment);
            formData.append("rate", this.rating);

            this.$API
                .post(this.$SubmitFeedbacks, formData)
                .then((response) => {
                    if (response.data.status === 400) {
                        this.Loading = false;
                        this.Message = response.data.message;
                        this.Error = true;
                    }
                    if (response.status == 200) {
                        if (response.data.status !== 400) {
                            if (response.data.status !== 400) {

                                this.SuccessPopup = true;
                            } else {
                                this.Loading = false;
                                this.Message = response.data.message;
                                this.Error = true;
                            }
                        } else {
                            this.Loading = false;
                            this.Message = response.data.message;
                            this.Error = true;
                        }
                    } else {
                        this.Loading = false;
                        this.Error = true;
                        this.Message = response.data.message;
                    }
                })
                .catch((error) => {
                    this.Loading = false;
                    this.Error = true;
                    this.Message = error.response.data.message;
                });
        },
        closeSuccessFeedback() {
            this.SuccessPopup = false;
            this.$router.push("/");
        },
        GoToLogin() {
            let path = this.$router.currentRoute.path;
            if (path.toLowerCase() != "/Login") {

                this.$router.push({
                    path: '/Login',
                    query: {
                        targetUrl: this.$router.currentRoute.fullPath,
                    }
                })

            }
        },
        ShowQuestionSurvey() {
            this.showMain = false;
            this.showStartSurvey = true;
        },
        OpenPopup() {
            this.showPopup = true; // Keep the popup open on click
        },
        GoToTrial() {
            this.showPopup = false;
            window.open("https://www.interviewrr.ai/directinterview?code=wbxUkS");
        },
        SubmitEmail() {
            this.PopupFeedback = false;
            const formData = new FormData();
            formData.append("sessionId", this.sess.Id);

            this.$API
                .post(this.$SendEmailAI, formData, {
                    withCredentials: true,
                })
                .then((response) => {
                    if (response.data.status === 400) {
                        this.Loading = false;
                        this.Message = response.data.message;
                        this.Error = true;
                    }
                    if (response.status == 200) {
                        if (response.data.status !== 400) {
                            if (response.data.status !== 400) {


                            } else {
                                this.Loading = false;
                                this.Message = response.data.message;
                                this.Error = true;
                            }
                        } else {
                            this.Loading = false;
                            this.Message = response.data.message;
                            this.Error = true;
                        }
                    } else {
                        this.Loading = false;
                        this.Error = true;
                        this.Message = response.data.message;
                    }
                })
                .catch((error) => {
                    this.Loading = false;
                    this.Error = true;
                    this.Message = error.response.data.message;
                });
        },
        async InsertReport() {

            try {
                const response = await this.$API.get(`${this.$GenerateReport}?session_id=` + this.sess.Id);
                if (response.status === 200) {


                } else {

                }
            } catch (error) {

            }
        },
        toggleNotes() {
            this.showNotes = !this.showNotes;
        },


        triggerFileInput() {
            this.$refs.fileInput.click(); // Opens file picker
        },
        handleFileSelect(event) {
            const files = Array.from(event.target.files);
            this.processFiles(files);
        },
        handleDrop(event) {
            event.preventDefault();
            const files = Array.from(event.dataTransfer.files);
            this.processFiles(files);
        },
        processFiles(files) {
            files.forEach((file) => {
                if (file.size <= 10 * 1024 * 1024) { // 10MB Limit
                    // Add the file to uploadedFiles only once, before uploading
                    if (!this.uploadedFiles.some(f => f.name === file.name)) {
                        this.uploadedFiles.push({ name: file.name, uploading: true });
                        this.uploadFile(file); // Start the upload for this file
                    }
                } else {
                    alert("File size exceeds 10MB!");
                }
            });
        },
        async uploadFile(file) {
            const formData = new FormData();
            formData.append("file", file);
            formData.append("userId", this.user.id);
            formData.append("sessionId", this.sess.Id);

            try {
                const response = await this.$API.post(this.$uploadDocument, formData, {
                    headers: { "Content-Type": "multipart/form-data" },
                    withCredentials: true,
                    onUploadProgress: (progressEvent) => {
                        const percentCompleted = Math.round((progressEvent.loaded / progressEvent.total) * 100);
                        this.$set(this.uploadProgressBar, file.name, percentCompleted);
                    },
                });

                if (response.status === 200) {
                    console.log("File uploaded successfully:", file.name);

                    // Remove the file from uploading state
                    this.uploadedFiles = this.uploadedFiles.filter(f => f.name !== file.name);

                    // Refresh the document list from API after the upload completes
                    await this.getListDoc(this.sess.Id);
                } else {
                    console.error("Failed to upload file:", file.name);
                }
            } catch (error) {
                console.error("Upload error:", error);
                // Handle error gracefully, remove file from progress
                this.$delete(this.uploadProgressBar, file.name);
                this.uploadedFiles = this.uploadedFiles.filter(f => f.name !== file.name);
            }
        },
        removeFile: function(id) {
            const formData = new FormData();

            formData.append("fileId", id);

            return this.$API
                .post(this.$DeleteDocument, formData, {
                    withCredentials: true,
                })
                .then((response) => {
                    if (response.status == 200) {
                        this.getListDoc(this.sess.Id);
                    } else {
                        this.Busy = false;
                    }
                })
                .catch((error) => {
                    this.Busy = false;
                    this.Loading = false;
                    this.Error = true;
                    this.Message = error.response.data.message;
                });
        },
        async getListDoc(sessionId) {
            try {
                const response = await this.$API.get(this.$GetDocDetails + "?sessionId=" + sessionId, {
                    withCredentials: true,
                });

                if (response.status === 200) {
                    this.uploadedFiles = []; // Clear temporary files from the upload process
                    this.document = response.data; // Replace with the files fetched from the API
                }
            } catch (error) {
                console.error("Error fetching document list:", error);
            }
        },
        ClosePopupUpload()
        {
            this.showProcessUpload = false;
        }
    },

};
</script>

<style scoped>
@import url('https://fonts.cdnfonts.com/css/general-sans');
body {
    top: 0 !important;
    font-family: 'General Sans', sans-serif;
}

.video-container {
    position: relative;
    width: 100%;
    background-color: black;
    border-radius: 21px;
    max-width: 100%;
}

.button-container {
    position: absolute;
    top: 90%;
    left: 50%;
    transform: translate(-50%, -50%);
}

.record-button {
    width: 60px;
    height: 60px;
    border-radius: 50%;
    background-color: #f44336;
    color: white;
    font-size: 24px;
    border: none;
    cursor: pointer;
    transition: background-color 0.3s ease;
}

.record-button:hover {
    background-color: #d32f2f;
}

.record-button.recording {
    background-color: #8bc34a;
}

.record-button i {
    margin-top: 8px;
}

.hideAfterStop {
    display: none;
}

video {
    border-radius: 21px;
    width: 100%;
}

.disabled {
    pointer-events: none;
    opacity: 0.5;
}

.timer {
    position: absolute;
    top: 24px;
    right: 0px;
    -webkit-transform: translateX(-20%);
    transform: translateX(-20%);
    font-size: 20px;
    color: white;
    background: #F02222;
    padding: 5px 10px;
    border-radius: 17px;
}

@media (max-width: 768px) {
    .popup-all1 {
        width: 90%;
        max-width: 500px;
        padding: 20px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        background-color: #fff;
        border: 1px solid #ccc;
        border-radius: 20px;
        z-index: 1000;
        margin: 0 auto;
        margin-top: 50%;
    }
}

/* Container for the progress bar */

.progress-bar-container {
    width: 100%;
    background-color: #ddd;
    border-radius: 4px;
    height: 10px;
    margin-top: 5px;
    position: relative;
}

/* Style for the actual progress bar */

.progress-bar {
    height: 100%;
    background-color: #7F56D9;
    border-radius: 4px;
    transition: width 0.2s ease-in-out;
}

/* Style for the text inside the progress bar */

.progress-text {
    position: absolute;
    width: 100%;
    text-align: center;
    font-size: 12px;
    color: #fff;
    top: 50%;
    transform: translateY(-50%);
}
</style>